<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar
          v-model="formData"
          @search="handleSearch"
          @reset="handleReset"
          ref="search"
        ></search-bar>
      </el-header>
    </el-container>
    <div class="main">
      <div class="left">
        <div class="title">
          <strong style="width: 60%">搜索结果框</strong>
          <!-- <div style="text-align: right; width: 100%">
            <el-button type="primary" plain @click="addContrast"
              >加入对比</el-button
            >
          </div> -->
        </div>
        <div class="checkAll">
          <el-checkbox
            v-model="checkAll"
            @change="handleCheckALl"
            :disabled="
              contrastList.length > 4 || !contrastList.length ? true : false
            "
            ><strong>全选</strong></el-checkbox
          >
        </div>
        <div class="checkbox" v-loading="loading">
          <el-checkbox-group v-model="print" @change="checkChange">
            <div
              v-for="item in contrastList"
              :key="item.productCode"
              style="
                height: 60px;
                padding: 10px 0;
                border-bottom: 1px solid #e4e7ed;
                position: relative;
              "
            >
              <el-checkbox :label="item.productCode" :key="item.productCode"
                ><strong>{{ item.productName }}</strong>
                <div
                  style="
                    height: 19.2px;
                    position: absolute;
                    top: 34.56px;
                    color: #606266;
                  "
                >
                  <span v-if="item.color">颜色：</span
                  ><span class="textpdding" v-if="item.color">{{
                    item.color
                  }}</span>
                  <span v-if="item.productPrice">日常活动到手价：</span
                  ><span class="textpdding" v-if="item.productPrice">{{
                    item.productPrice
                  }}</span>
                  <span v-if="item.style">风格：</span
                  ><span class="textpdding" v-if="item.style">{{
                    item.style
                  }}</span>
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div style="text-align: right; margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-size="paginationOpt.pageSize"
            layout="total, prev, pager, next"
            small
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="right">
        <div class="title"><strong>产品信息对比</strong></div>
        <div style="padding: 10px 20px; height: calc(100% - 100px)">
          <el-checkbox
            @change="hidePriceChange(hidePrice)"
            v-model="hidePrice"
            :disabled="propList.length < 1"
            >隐藏价格项</el-checkbox
          >
          <el-table
            border
            :data="hideSame ? tbaleHide : !hidePrice ? tableData : tbaleHide"
            :row-style="{ height: '50px' }"
            :cell-style="rowCompare"
            height="calc(100% - 10px)"
            width="100%"
            v-if="tableHeight"
          >
            <template v-for="(item, index) in columnData">
              <el-table-column
                :key="item.prop"
                :label="item.label"
                width="160px"
                align="center"
                :prop="item.prop"
                v-if="item.label === '产品基本参数'"
                class="headerFirst"
              >
                <template #header>
                  <div class="header-frist">
                    <strong style="color: #606266; height: 70px"
                      >产品基本参数</strong
                    >
                    <el-checkbox
                      v-model="hideSame"
                      :disabled="propList.length < 2"
                      >隐藏相同项</el-checkbox
                    >
                  </div>
                </template>
                <template slot-scope="scope">
                  <strong style="color: #606266">{{
                    scope.row[item.prop]
                  }}</strong>
                </template>
              </el-table-column>
              <el-table-column
                :key="item.prop"
                :label="item.label"
                :prop="item.prop"
                align="center"
                v-else
              >
                <template #header>
                  <template v-if="propList[index - 1]">
                    <div>
                      <el-image
                        :src="
                          propList[index - 1].photoUrls
                            ? propList[index - 1].photoUrls
                            : img_err
                        "
                        fit="contain"
                      ></el-image>
                    </div>
                    <el-button
                      type="primary"
                      icon="el-icon-close"
                      @click="tableDel(index, propList[index - 1].productCode)"
                    ></el-button>
                    <div style="width: 100%">
                      {{ propList[index - 1].productName }}
                    </div>
                  </template>
                  <div v-else>待加入产品信息</div>
                </template>
                <template slot-scope="scope">
                  {{ scope.row[item.prop] | cellValFormat }}
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 导入导出 -->
  </div>
</template>

<script>
import searchBar from "./search";
import img_err from "@/assets/images/img_err.png";
import moment from "moment";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "ProductComparison",
  mixins: [pagePathMixin],
  components: {
    searchBar,
  },
  data() {
    return {
      img_err,
      tableHeight: 0,
      loading: false,
      loading2: false,
      formData: {},
      tableData: [],
      exportData: {},
      columnsData: [],
      recordDialogVisible: false,
      propListTwo: [],
      print: [],
      printTwo: [],
      columnData: [],
      checkAll: false,
      propList: [],
      hideSame: false,
      hidePrice: true,
      paginationOpt: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      tableDataTwo: [],
      contrastList: [],
      priceChang: false,
      dataAll: [],
      searchType: false,
      amountHideFlag: false,
      searchIndex: 0,
    };
  },
  watch: {
    hideSame(val) {
      console.log(this.tableDataTwo);
    },
  },
  computed: {
    sortedPropList() {
      let data = [
        {
          label: "品类",
          prop: "categoryName",
          width: "100px",
          sortable: false,
          span: false,
          fixed: false,
          align: "left",
        },
        {
          label: "销量",
          prop: "productSales",
          width: "100px",
          sortable: "custom",
          span: false,
          fixed: false,
          align: "right",
        },
        {
          label: "销售额占比",
          prop: "saleProportion",
          width: "120px",
          sortable: "custom",
          span: false,
          fixed: false,
          align: "right",
        },
        {
          label: "销售额",
          prop: "salesVolume",
          width: "130px",
          sortable: "custom",
          span: false,
          fixed: false,
          align: "right",
        },
      ];
      return data;
    },
    tbaleHide() {
      if (this.hideSame) {
        this.tableDataTwo = this.tableDataTwo.filter(
          (v) => v.type != "日常活动到手价" && v.type != "最低成交金额"
        );
        this.tableDataTwo.push(
          ...this.tableData.filter(
            (v) => v.type == "日常活动到手价" || v.type == "最低成交金额"
          )
        );
        var datawilldele = []; //2,4,5
        this.tableDataTwo.forEach(function (v, i) {
          if (!v[0] && !v[1] && !v[2] && !v[3]) {
            console.log(v);
            datawilldele.push(i);
          }
          if (v[0] && v[1] && v[2] && v[3]) {
            if (v[0] == v[1] && v[0] == v[2] && v[0] == v[3]) {
              console.log(v);
              datawilldele.push(i);
            }
          }
          if (v[0] && v[1] && v[2] && !v[3]) {
            if (v[0] == v[1] && v[0] == v[2]) {
              console.log(v);
              datawilldele.push(i);
            } else {
            }
          }
          if (v[0] && v[1] && !v[2] && !v[3]) {
            if (v[0] == v[1]) {
              console.log(v);
              datawilldele.push(i);
            } else {
            }
          }
        });
        console.log(datawilldele);
        for (var i = 0; i < datawilldele.length; i++) {
          this.tableDataTwo.splice(datawilldele[i] - i, 1);
        }
      }
      if (this.hidePrice && this.hideSame) {
        this.tableDataTwo = this.tableDataTwo.filter(
          (v) => v.type != "日常活动到手价" && v.type != "最低成交金额"
        );
        // } else if (!this.priceChang && this.hideSame) {
        //   this.tableDataTwo = this.tableDataTwo.filter((v) => v.type != "日常活动到手价" && v.type!= "最低成交金额");
        //   this.tableDataTwo.push(
        //     ...this.tableData.filter((v) => v.type == "日常活动到手价" || v.type == "最低成交金额")
        //   );
      } else if (this.hidePrice && !this.hideSame) {
        this.tableDataTwo = this.tableData.filter(
          (v) => v.type != "日常活动到手价" && v.type != "最低成交金额"
        );
      }
      console.log(this.tableDataTwo);
      this.tableDataTwo = [...new Set(this.tableDataTwo)];
      return this.tableDataTwo;
    },
  },
  mounted() {
    this.tableHeight =
      this.$refs["wrapper"].offsetHeight -
      this.$refs["search"].$el.offsetHeight -
      91;
    this.init();
  },
  methods: {
    hidePriceChange(data) {
      this.priceChang = data;
    },
    handleCheckALl() {
      if (this.print.length > 4) {
        this.$message.error("已超过4个产品，请核对！");
        return;
      }
      if (this.checkAll) {
        if (this.searchType) {
          this.print.push(...this.contrastList.map((v) => v.productCode));
        } else {
          this.print = this.contrastList.map((v) => v.productCode);
        }
      } else {
        let code = this.contrastList.map((v) => v.productCode);
        this.print = this.print.filter((v) => !code.includes(v));
      }
      let data = [];
      this.print = [...new Set(this.print)];
      console.log(this.print);
      this.dataAll.forEach((v) => {
        if (
          v.productCode == this.print[0] ||
          v.productCode == this.print[1] ||
          v.productCode == this.print[2] ||
          v.productCode == this.print[3]
        ) {
          data.push(v);
        }
      });
      if (this.searchType) {
        this.printTwo.push(...data);
      } else {
        this.printTwo = data;
      }
      let code = this.printTwo.map((v) => v.productCode);
      this.printTwo = this.printTwo.filter((v, index) =>
        code.includes(this.print[index])
      );
      console.log(this.printTwo);
      this.init(true);
    },
    checkChange(val) {
      // val.length == this.contrastList.length + this.printTwo.length  ||
      if (
        val.length == this.contrastList.length &&
        this.paginationOpt.total < 11
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      if (this.print.length > 4 || this.printTwo.length > 4) {
        this.print = this.print.slice(0, 4);
        this.$message.error("已超过4个产品，请核对！");
        return;
      }
      let data = [];
      this.dataAll.forEach((v) => {
        if (
          v.productCode == this.print[0] ||
          v.productCode == this.print[1] ||
          v.productCode == this.print[2] ||
          v.productCode == this.print[3]
        ) {
          data.push(v);
        }
      });
      if (this.searchType || this.searchIndex > 1) {
        this.printTwo.push(...data);
        let obj = {}
        this.printTwo = this.printTwo.reduce(function (item, next) {  //根据code去重
          obj[next.productCode] ? "" : (obj[next.productCode] = true && item.push(next));
          return item;
        }, []);
      } else {
        this.printTwo = data;
      }
      let code = this.printTwo.map((v) => v.productCode);
      this.printTwo = this.printTwo.filter((v, index) =>
        code.includes(this.print[index])
      );
      this.init(true);
    },
    // addContrast() {
    //   if (this.print.length > 4 || this.printTwo.length >4) {
    //     this.$message.error("已超过4个产品，请核对！");
    //     return;
    //   } else if (!this.print.length) {
    //     this.$message.error("请先选择产品，请核对！");
    //     return;
    //   }
    //   let data = []
    //   console.log(this.print);
    //   this.dataAll.forEach(v=>{
    //     if(v.productCode == this.print[0] || v.productCode == this.print[1] || v.productCode == this.print[2] || v.productCode == this.print[3] ) {
    //       data.push(v)
    //     }
    //   })
    //   if( this.searchType) {
    //     this.printTwo.push(...data)
    //   }else {
    //     this.printTwo = data
    //   }
    //   let code = this.printTwo.map(v=>v.productCode)
    //   this.printTwo = this.printTwo.filter((v,index)=>code.includes(this.print[index]))
    //   console.log(this.printTwo );
    //   this.init(true);
    // },
    tableDel(index, productCode) {
      this.propList.splice(index - 1, 1);
      // this.print.splice(index - 1, 1);
      this.print = this.print.filter((v) => v != productCode);
      this.checkAll = false;
      this.init(true);
      // this.print.splice(index-1,1)
    },
    async handleSearch(data) {
      this.searchIndex += 1;
      this.paginationOpt.pageNum = 1;
      this.formData = data;
      if (this.contrastList.length) {
        this.searchType = true;
      }
      // this.print = [];
      this.checkAll = false;
      await this.init2(true);
    },
    handleReset() {
      this.paginationOpt.pageNum = 1;
      this.paginationOpt.total = 0;
      this.contrastList = [];
      this.print = [];
      this.checkAll = false;
      this.printTwo = [];
      this.propList = [];
      this.init(true);
    },
    init2(type) {
      this.loading = true;
      let formData = {
        exportTag: true,
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          ...this.formData,
        },
      };
      this.$q.intelligentRecom
        .productComparison({ data: formData })
        .then((res) => {
          if (res.data.pageResult.records.length && res.code == 200) {
            this.contrastList = res.data.pageResult.records;
            this.dataAll = res.data.listResult;
            if (this.contrastList.length) {
              let data = [];
              Object.keys(this.contrastList[0]).forEach((key) => {
                data.push(key);
              });
              this.$nextTick((_) => {
                this.amountHideFlag = data.includes("minAmount");
              });
            }
            this.paginationOpt["total"] = res.data.pageResult.total;
          } else {
            this.paginationOpt["total"] = 0;
            this.contrastList = [];
          }
        })
        .finally((_) => {
          if (type) {
            this.init(true);
          }
          this.loading = false;
        });
    },
    init(type) {
      this.$nextTick((_) => {
        this.propList = this.printTwo;
      });
      this.columnData = [];
      let col = [];
      this.amountHideFlag
        ? col = [
            "风格",
            "材质",
            "尺寸",
            "规格",
            "颜色",
            "长",
            "宽",
            "高",
            "重量",
            "功能",
            "日常活动到手价",
            "最低成交金额",
          ]
        : col = [
            "风格",
            "材质",
            "尺寸",
            "规格",
            "颜色",
            "长",
            "宽",
            "高",
            "重量",
            "功能",
            "日常活动到手价",
          ];
      let data = [
        {
          style: "",
          material: "",
          productSize: "",
          specDesc: "",
          color: "",
          productPrice: "",
          minAmount: "",
          sizeLength: "",
          sizeWidth: "",
          sizeHeight: "",
          weifhtInfo: "",
          functionality: "",
        },
        {
          style: "",
          material: "",
          productSize: "",
          specDesc: "",
          color: "",
          productPrice: "",
          minAmount: "",
          sizeLength: "",
          sizeWidth: "",
          sizeHeight: "",
          weifhtInfo: "",
          functionality: "",
        },
        {
          style: "",
          material: "",
          productSize: "",
          specDesc: "",
          color: "",
          productPrice: "",
          minAmount: "",
          sizeLength: "",
          sizeWidth: "",
          sizeHeight: "",
          weifhtInfo: "",
          functionality: "",
        },
        {
          style: "",
          material: "",
          productSize: "",
          specDesc: "",
          color: "",
          productPrice: "",
          minAmount: "",
          sizeLength: "",
          sizeWidth: "",
          sizeHeight: "",
          weifhtInfo: "",
          functionality: "",
        },
      ];
      if (type) {
        data.forEach((v, index) => {
          if (this.printTwo[index]) {
            data[index] = this.printTwo[index];
          }
        });
      }
      // 设置表头
      let columnData = [];
      data.forEach((item, index) => {
        let obj = {
          label: "待加入产品信息",
          prop: String(index),
        };
        columnData.push(obj);
      });
      columnData.unshift({
        label: "产品基本参数",
        prop: "type",
      });
      this.$nextTick((_) => {
        this.columnData = columnData;
      });
      //  style: "",
      //     material: "",
      //     productSize: "",
      //     specDesc: "",
      //     color: "",
      //     productPrice: "",
      //     minAmount: "",
      //     sizeLength: "",
      //     sizeWidth: "",
      //     sizeHeight: "",
      //     weifhtInfo: "",
      //     functionality: "",
      let table = [];
      for (let index = 0; index < col.length; index++) {
        let obj = {};
        obj["type"] = col[index];
        for (let k = 0; k < data.length; k++) {
          if (index == 0) {
            obj[String(k)] = data[k]["style"];
          } else if (index == 1) {
            obj[String(k)] = data[k]["material"];
          } else if (index == 2) {
            obj[String(k)] = data[k]["productSize"];
          } else if (index == 3) {
            obj[String(k)] = data[k]["specDesc"];
          } else if (index == 4) {
            obj[String(k)] = data[k]["color"];
          } else if (index == 5) {
            obj[String(k)] = data[k]["sizeLength"];
          } else if (index == 6) {
            obj[String(k)] = data[k]["sizeWidth"];
          } else if (index == 7) {
            obj[String(k)] = data[k]["sizeHeight"];
          } else if (index == 8) {
            obj[String(k)] = data[k]["weifhtInfo"];
          } else if (index == 9) {
            obj[String(k)] = data[k]["functionality"];
          } else if (index == 10) {
            obj[String(k)] = data[k]["productPrice"];
          } else if (index == 11) {
            obj[String(k)] = data[k]["minAmount"];
          }
        }
        table.push(obj);
      }
      this.tableData = table;
      this.tableDataTwo = JSON.parse(JSON.stringify(table));
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      console.log(val);
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init2();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      if (this.checkAll) {
        this.print = [];
        this.checkAll = [];
      }
      this.searchType = true;
      this.paginationOpt.pageNum = val;
      this.init2();
    },
    rowCompare({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "background: #F5F7FA";
      }
      if (columnIndex == 2) {
        if (row[1] != row[0] && columnIndex > 1) {
          return "color: #FF3300";
        }
      }

      if (columnIndex == 3) {
        if (row[2] != row[0] && columnIndex > 1) {
          return "color: #FF3300";
        }
      }
      if (columnIndex == 4) {
        if (row[3] != row[0] && columnIndex > 1) {
          return "color: #FF3300";
        }
      }
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 5px 5px 10px 5px;
  width: auto;
  height: calc(100% - 15px);
  box-sizing: border-box;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.main {
  height: calc(100% - 50px);
  // padding: 5px 8px;
  display: flex;
  flex-wrap: nowrap;
}

.left {
  // height: 100%;
  // border: 1px solid #c4c4c4;
  // border-radius: 3px;
  width: 370px;
  border-radius: 5px;
  background: #ffffff;
  // background-color: red;
}

.right {
  height: 100%;
  width: calc(100% - 370px);
  margin-left: 5px;
  background: #ffffff;
  border-radius: 5px;
  // width: calc(75% - 10px);
  // background-color: blue;
}

.title {
  font-size: 16px;
  color: #444;
  padding: 20px 9.6px 20px 9.6px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

// .el-icon-plus {
// font-size: 14px;
// font-weight: 500;
// }
.checkAll {
  padding: 0px 0 5px 9.6px;
}

>>> .checkAll .el-checkbox__label {
  padding: 9.6px 19.2px 0 19.2px;
  font-size: 14px;
}

.checkbox {
  height: calc(100% - 150px);
  width: 100%;
  color: #606266;
  overflow-x: hidden;
}

>>> .el-pagination {
  width: 330px;
}

>>> .checkbox .el-checkbox {
  display: flex;
  justify-items: top;
}

>>> .checkbox .el-checkbox__label {
  padding: 9.6px 19.2px 0 19.2px;
  font-size: 14px;
}

// >>> .checkbox .el-checkbox__inner {
// margin-left: 19.2px;
// }
>>> .checkbox .el-checkbox__input {
  padding-top: 12.48px;
}

>>> .checkbox .el-checkbox-group {
  border: none !important;
  padding: 0px 9.6px;
}

>>> ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

>>> .el-table th>.cell {
  // white-space: pre-line
  height: 15vw;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.header-frist {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

>>> .el-table th {
  background: #fff !important;
  position: relative;
}

>>> .el-image__inner {
  width: auto;
  max-height: 24vh;
}

.right >>> .el-button {
  padding: 1px;
  position: absolute;
  right: 0;
  top: 0;
}

.textpdding {
  display: inline-block;
  padding-right: 10px;
}

.right >>> .el-checkbox {
  margin-right: 0;
}
</style>